<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" @hidden="hidden">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-center"> <b>{{obj.xtitle}}</b> </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body text-center">
                <p> <b>Estudiante: </b> {{parseEstudiante(inscripcion.estudiante)}} </p>
                <p class="text-primary text-left"> Cuotas por pagar </p>
                <div class="table-responsive">
                  <table class="table table-hover table-condensed table-striped table-borderless">
                    <thead>
                      <tr>
                        <th>Cuota</th>
                        <th>Monto</th>
                        <th>Saldo</th>
                        <th>Fecha</th>
                        <th>Subpagos</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-bind:key="ind" v-for="(c,ind) in inscripcion.cuotas_por_pagar">
                        <td> {{c.nro_cuota}} </td>
                        <td> {{c.monto}} Bs. </td>
                        <td> {{c.saldo}} Bs.</td>
                        <td> {{c.fecha}} </td>
                        <td>
                          <div v-bind:key="inn" v-for="(p,inn) in c.pagos">
                            <p style="margin-bottom:0;margin-top:0"> <small> <b>Monto: </b> {{p.monto}} Bs. </small> </p>
                            <p style="margin-bottom:0;margin-top:0"> <small> <b>Saldo: </b> {{p.saldo}} Bs. </small> </p>
                            <p style="margin-bottom:0;margin-top:0"> <small> <b>Fecha: </b> {{p.fecha_pago}}  </small> </p>
                            <p style="margin-bottom:0;margin-top:0"> <small> <b>Recibo: </b> {{p.nro_recibo}}  </small> </p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <p class="text-primary text-left" v-if="inscripcion.cuotas_canceladas.length"> Cuotas canceladas </p>
                <div class="table-responsive" v-if="inscripcion.cuotas_canceladas.length">
                  <table class="table table-hover table-condensed table-striped table-borderless">
                    <thead>
                      <tr>
                        <th>Cuota</th>
                        <th>Monto</th>
                        <th>Saldo</th>
                        <th>Fecha</th>
                        <th>Subpagos</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-bind:key="ind" v-for="(c,ind) in inscripcion.cuotas_canceladas">
                        <td> {{c.nro_cuota}} </td>
                        <td> {{c.monto}} Bs.</td>
                        <td> {{c.saldo}} Bs.</td>
                        <td> {{c.fecha}} </td>
                        <td>
                          <div v-bind:key="inn" v-for="(p,inn) in c.pagos">                        
                            <p style="margin-bottom:0;margin-top:0"> <small> <b>Monto: </b> {{p.monto}} Bs. </small> </p>
                            <p style="margin-bottom:0;margin-top:0"> <small> <b>Saldo: </b> {{p.saldo}} Bs. </small> </p>
                            <p style="margin-bottom:0;margin-top:0"> <small> <b>Fecha: </b> {{p.fecha_pago}}  </small> </p>
                            <p style="margin-bottom:0;margin-top:0"> <small> <b>Recibo: </b> {{p.nro_recibo}}  </small> </p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
            </div>

            <Alertas 
                ref="alertar" 
                v-bind:msgSuccess="'El cambio de estado se realizo satisfactoriamente.'"
                v-bind:msgLoading="'Cargando datos...'"
                />
            <div class="modal-footer">
                <button @click="submit" v-if="activo" type="button" class="btn btn-azul">Aceptar</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import Alertas from '@/components/AAlertas.vue'
import {parseJsonError} from '@/components/Utils.js'
    export default {
        props: {
            obj:{ // {xid:Number,xtitle:String,xbody:String,xsql:Object}
                type: Object,
                required: true
            },
        },
        data(){
            return{
                activo: true,
                inscripcion: {
                  cuotas_canceladas: []
                },
            }
        },
        watch:{
            'obj.xid': function(){ 
              if( this.obj.xid == null ) return;
              this.$refs.alertar.cargando(); 
              this.activo = true;
              this.getDatos( this.obj.xsql );
            }
        },
        components:{Alertas},
        methods:{
            hidden(){ this.$refs.alertar.cargando(); },
            async getDatos( sql ){
              await this.$apollo.query({
                query: sql,
              }).then((data) => {
                  // window.console.log( "DATA ",data.data)
                  this.obj.xid = null;
                  this.inscripcion = data.data.getInscripcion;
                  this.$refs.alertar.reset(); 
              }).catch((error) => {
                  window.console.error(error)
                  this.$notify( parseJsonError( error,'getPrograma' ) )
              });
            },
            parseEstudiante( e ){
              if( e == null ) return "";
              return e.nombres+' '+e.pri_apellido;
            },
            submit(){
                // window.console.log( "ZZZZ ",this.obj.xsql,typeof(this.obj.xsql) );
                var vue = this;
                vue.$refs.alertar.cargando();
                vue.activo = false;

                this.$apollo.mutate({
                    mutation: vue.obj.xsql,
                }).then((/*data*/) => {
                    // window.console.log(data);
                    vue.$refs.alertar.success();
                    this.$emit('exito')
                }).catch((error) => {
                    window.console.error(error);
                    vue.$refs.alertar.invalido();
                })
            }
        },
    
    }
</script>